/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class DvpgCreateWizardFlags{
      isNameAndLocationPageInitialized: boolean;
      isGeneralPropertiesPageInitialized: boolean;
   }
}
